import type { FC, ReactText } from 'react';
import React from 'react';
import type { TInputType } from '@alfa-bank/site-pure-input/src/models';
import { StaticActions as actions } from '@alfa-bank/site-form-utils/actions';
import { Input as BaseInput } from '@alfa-bank/site-input';
import cn from 'classnames';
import { Field } from '@alfa-bank/site-form-utils/components/form-field';
import { isSuccess } from '@alfa-bank/site-form-helpers/meta/is-success';
import { isError } from '@alfa-bank/site-form-helpers/meta/is-error';
import { getCaption } from '@alfa-bank/site-form-helpers/meta/get-caption';
import type { FieldValidator } from 'final-form';

import styles from './styles.css';
import type { TPromo } from './models';
import { MAX_PROMOCODE_LENGTH, validatePromocode } from './helper';

export const Promocode: FC<TPromo> = ({ name, settings }) => {
    return (
        <Field
            data={settings}
            name={name}
            render={({ input, meta }) => {
                return (
                    <div className={cn(styles.wrapper)}>
                        <BaseInput
                            {...input}
                            caption={getCaption(meta)}
                            error={isError(meta)}
                            onBlur={actions.onBlur(input)}
                            onCancel={actions.onCancel({ input, meta })}
                            onChange={({ value }) => {
                                const formattedValue = String(value)
                                    .replace(/\s/g, '')
                                    .substring(0, MAX_PROMOCODE_LENGTH);
                                actions.onChange(input)(formattedValue);

                                if (!validatePromocode()(String(value))) {
                                    actions.onComplete({ input, meta });
                                }
                            }}
                            onFocus={() => input.onFocus()}
                            placeholder={settings.placeholder}
                            success={isSuccess(meta)}
                            type={input.type as TInputType}
                            value={input.value as ReactText}
                        />
                    </div>
                );
            }}
            validate={validatePromocode() as FieldValidator<unknown>}
        />
    );
};
